import styled from 'styled-components';

import {
    primaryColor,
    primaryColorLight,
    primaryColorStrong,
    primaryColorWeak,
    subMenuComponentBackground
} from '../../config/colors';

export const PrintWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  width: 100%;
`;
export const IdCardWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  width: 100%;
  border-bottom: 1px darkGray solid;
  border-right: 0px;
  border-left: 0px;
  border-top: 0.5px darkGray solid;
  padding-bottom: 60px;
`;

export const PreparingForPrintingTitle = styled.h1`
  color: red;
  align-self: center;
  margin-bottom: 30px;
`;

export const Header = styled.div`
  display: flex;
  width: 100%;
  height: 90px;
  padding-right: 10px;
  margin-bottom: 20px;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
  background-color: #D4D4D4;
  position: relative;
`;

export const IdCardText = styled.h2`
  height: 100%;
  margin: 0;
  font-weight: 600;
  margin-left: 20px;
`;


export const Ribbon = styled.div`
  width: 13px;
  height: 100%;
  background-color: ${primaryColorStrong};
  position: absolute;
`;

export const ModuleHeader = styled.div`
  height: 25px;
  width: 100%;
  display: flex;
  align-items: center;
  position: relative;
`;

export const ModuleTitle = styled.p`
  padding: 10px 15px 10px 23px;
  font-weight: 600;
  font-size: 1rem;
  color: ${primaryColorStrong};
`;

export const Project = styled.h1`
  height: 100%;
  display: flex;
  margin: 0;
  margin: auto 0;
  font-weight: 600;
  align-items: center;
`;

export const FastForwardLogo = styled.img`
  height: 80%;
  width: 100px;
`;

export const SectionWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const TextualAndImageWrapper = styled.div`
  display: flex;
  flex-direction: row;
  box-sizing: border-box;
  padding: 0 10px;
  justify-content: space-between;
`;

export const ViewsAndLayoutImageAndTitleWrapper = styled.div`
  width: 37%;
  height: 325px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const SubMenusWrapper = styled.ul`
  flex: 1;
  display: flex;
  flex-direction: row;
  margin-top: 20px;
  float: none;
  
`;

export const SectionTitle = styled(ModuleTitle)`
  margin-left: 15px;
  min-height: 3em;
`;

export const ImageWrapper = styled.div`
  display: inline-flex;
  flex-direction: column;
  flex:1;
  margin-left: 20px;
`;

export const CharacteristicsAndModulesWrapper = styled.div`
  display: flex;
  flex-direction: row;
  page-break-inside: avoid;
  @media print {
    page-break-inside: avoid;
    padding: 0;
  }
`;

export const CharacteristicsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

export const CharacteristicsSectionWrapper = styled.div`
  margin-bottom: 20px;
`;

export const CharacteristicWrapper = styled.div`
  display: flex;
  flex-direction: row;
  margin-left: 15px;
  margin-bottom: 3px;
`;

export const CharacteristicTitle = styled.div`
  flex: 1;
  color: ${primaryColorLight}
`;

export const CharacteristicValue = styled.div`
  flex: 1;
`;

export const ModulesWrapper = styled.div`
  flex-direction: column;
  flex: 1;
`;

export const ModuleWrapper = styled.div`
  display: flex;
  flex-direction: row;
  height: 35px;
  cursor: pointer;
`;

export const ModuleImage = styled.div`
  flex: 1;
`;

export const ModuleNameWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex: 5;
  align-items: center;
  &:hover {
    color: ${primaryColor};
  }
`;

export const ModuleTsCode = styled.div`
  flex: 1;
`;

export const ModuleName = styled.div`
  flex: 4;
`;
export const DescriptionWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;
export const DescriptionTitle = styled.div`
  font-weight: 500;
  font-size: 1.25rem;
`;
